// PartBPage6.jsx - Secondary Stage Part B Page 6 (Rubric Assessment) for HPC Report
import React from 'react';

const PartBPage6 = ({ data }) => {
  const rubric = data?.rubric || {
    awareness_level: null,
    sensitivity_level: null,
    creativity_level: null
  };

  const levels = [
    { key: 'beginner', label: 'Beginner', score: 5 },
    { key: 'proficient', label: 'Proficient', score: 10 },
    { key: 'advanced', label: 'Advanced', score: 15 }
  ];

  const renderRubricRow = (ability, selectedLevel, bgColor) => {
    return (
      <tr>
        <td style={{
          backgroundColor: bgColor,
          padding: '50px 12px',
          fontWeight: 'bold',
          fontSize: '12px',
          border: '2px solid #F4824C',
          verticalAlign: 'middle',
          textAlign: 'left'
        }}>
          {ability}
        </td>
        {levels.map(level => (
          <td key={level.key} style={{
            backgroundColor: bgColor,
            padding: '40px 20px',
            border: '2px solid #F4824C',
            textAlign: 'center',
            verticalAlign: 'bottom'
          }}>
            <div style={{
              width: '20px',
              height: '20px',
              border: '2px solid #F4824C',
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '14px',
              backgroundColor: 'white'
            }}>
              {selectedLevel === level.key && '✓'}
            </div>
          </td>
        ))}
      </tr>
    );
  };

  return (
    <div className="report-page" style={{
      width: '210mm',
      minHeight: '297mm',
      padding: '20mm',
      backgroundColor: 'white',
      boxSizing: 'border-box',
      fontFamily: 'Arial, sans-serif',
      position: 'relative'
    }}>
      {/* Decorative Corners */}
      <div style={{
        position: 'absolute',
        top: 0,
        right: 0,
        width: 0,
        height: 0,
        borderStyle: 'solid',
        borderWidth: '0 80px 80px 0',
        borderColor: 'transparent #F4824C transparent transparent'
      }} />

      {/* Header */}
      <div style={{
        backgroundColor: '#F4824C',
        color: 'white',
        fontSize: '14px',
        fontWeight: 'bold',
        padding: '10px',
        textAlign: 'center',
        marginBottom: '20px'
      }}>
        Stage 3
      </div>

      {/* Instructions */}
      <div style={{
        fontSize: '11px',
        marginBottom: '16px',
        lineHeight: '1.5',
        textAlign: 'justify'
      }}>
        Based on the contents of the final output of the project, write a rubric for each ability and achievement level. Tick (✓) as per the learner's performance.
      </div>

      {/* Rubric Table */}
      <table style={{
        width: '100%',
        borderCollapse: 'collapse',
        marginBottom: '20px'
      }}>
        <thead>
          <tr>
            <th style={{
              backgroundColor: '#FFE5D5',
              border: '2px solid #F4824C',
              padding: '0',
              width: '20%'
            }}></th>
            {levels.map(level => (
              <th key={level.key} style={{
                backgroundColor: '#FFE5D5',
                border: '2px solid #F4824C',
                padding: '10px',
                textAlign: 'center',
                width: '26.67%'
              }}>
                <div style={{ fontWeight: 'bold', fontSize: '12px', marginBottom: '4px' }}>
                  {level.label}
                </div>
                <div style={{
                  width: '28px',
                  height: '28px',
                  border: '2px solid #F4824C',
                  borderRadius: '50%',
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontWeight: 'bold',
                  fontSize: '12px',
                  backgroundColor: 'white'
                }}>
                  {level.score}
                </div>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {renderRubricRow('Awareness', rubric.awareness_level, '#FFE5D5')}
          {renderRubricRow('Sensitivity', rubric.sensitivity_level, 'white')}
          {renderRubricRow('Creativity', rubric.creativity_level, '#FFE5D5')}
        </tbody>
      </table>

      {/* Page Number */}
      <div style={{
        position: 'absolute',
        bottom: '15mm',
        left: '50%',
        transform: 'translateX(-50%)',
        fontSize: '10px',
        color: '#666',
        fontWeight: 'bold'
      }}>
        15
      </div>

      {/* Bottom decorative corners */}
      <div style={{
        position: 'absolute',
        bottom: 0,
        left: 0,
        width: 0,
        height: 0,
        borderStyle: 'solid',
        borderWidth: '60px 0 0 60px',
        borderColor: 'transparent transparent transparent #F4824C'
      }} />
      <div style={{
        position: 'absolute',
        bottom: 0,
        right: 0,
        width: 0,
        height: 0,
        borderStyle: 'solid',
        borderWidth: '60px 60px 0 0',
        borderColor: 'transparent #F4824C transparent transparent',
        opacity: 0.3
      }} />
    </div>
  );
};

export default PartBPage6;
